import React from 'react';
import { motion } from 'framer-motion';
import './Events.css';

import mock_placement from '../assets/events/mock_placement.png';
import webathon from '../assets/events/webathon.png';
import paper_presentation from '../assets/events/paper_presentation.png';
import project_competition from '../assets/events/project_competition.png';
import agile from '../assets/events/agile.png';
import exploring from '../assets/events/exploring.jpg';
import flutter from '../assets/events/flutter.jpg';
import idea from '../assets/events/idea.jpg';
import navigate from '../assets/events/navigate.jpg';
import navigating_gate from '../assets/events/navigating_gate.jpg';
import pathway from '../assets/events/pathway.jpg';
import powerbi from '../assets/events/powerbi.jpg';
import women from '../assets/events/women.jpg';
import wordcamp from '../assets/events/wordcamp.jpg';
import workshop from '../assets/events/workshop.jpg';
import cloud from '../assets/events/cloud.jpeg';
import postercomp from '../assets/events/poster.jpg';
import python from '../assets/events/python.jpg';
import apptitude from '../assets/events/apptitude.jpg';
import hackathon from '../assets/events/hackathon.jpg';


const upcomingEvents = [
    {
        title: 'Shardeum Mini Hackathon',
        date: '20/09/2025',
        time: '09:00 AM',
        venue: 'IT Complex, PCE Nagpur',
        description: 'Join us for an exciting Shardeum Mini Hackathon! Collaborate, innovate, and create amazing projects using the Shardeum blockchain platform. Whether you\'re a beginner or an experienced developer, this event is open to all skill levels. Prizes await the best projects!',
        image: hackathon,
    },
    {
        title: 'Apptitude Test',
        date: '18/09/2025',
        time: '12:00 PM',
        venue: 'IT Building, PCE Nagpur',
        description: 'Sharpen your skills with our Apptitude Test! This event is designed to challenge your problem-solving abilities and enhance your logical thinking. It\'s a great opportunity to prepare for technical interviews and improve your aptitude skills. Don\'t miss out on this chance to excel!',
        image: apptitude,
    },     
    { 
        title: 'Guest Lecture on "Python for Data Science"', 
        date: '09/09/2025',
        time: '12:00 PM',
        venue: 'CT Seminar Hall, IT Building, PCE Nagpur',
        image: python,
    },
    { 
        title: 'Poster Competition', 
        date: '03/09/2025',
        time: '12:00 PM',
        venue: 'CT DBMS Lab, IT Complex, PCE Nagpur',
        image: postercomp,
    },    
    { 
        title: 'Workshop on "CLOUD SPHERE"', 
        date: '29/07/2025',
        time: '11:00 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: cloud,
    },
    { 
        title: 'Alumni Talk Series - 3 : Navigate Your IT Career Roadmap', 
        date: '17/07/2025',
        time: '11:00 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: navigate,
    },
    { 
        title: 'COMPUTSAV 2025 : Mock Placement Drive', 
        date: '28/02/2025',
        time: '11:00 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: mock_placement,
    },
    { 
        title: 'COMPUTSAV 2025 : Webathon', 
        date: '28/02/2025',
        time: '11:00 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: webathon,
    },
    { 
        title: 'COMPUTSAV 2025 : Workshop on "Automating 30% of your daily life with GenAI"', 
        date: '28/02/2025',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: workshop,
    },
    { 
        title: 'COMPUTSAV 2025 : Paper Presentation', 
        date: '27/02/2025',
        time: '11:00 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: paper_presentation,
    },
    { 
        title: 'COMPUTSAV 2025 : Project Competition', 
        date: '27/02/2025',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: project_competition,
    },
    { 
        title: 'Alumni Talk Series - 2 : Pathway to Career Clarity', 
        date: '12/02/2025',
        time: '12:00 PM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: pathway,
    },
    { 
        title: 'Women in Tech : Writing One Chapter At a Time', 
        date: '24/01/2025',
        time: '11:30 AM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: women,
    },
    { 
        title: 'Navigating Gate 2025 : Roadmap to Aspirants', 
        date: '21/01/2025',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: navigating_gate,
    },
    { 
        title: 'Alumni Talk Series - 1 : Exploring Data Engineering', 
        date: '16/01/2025',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: exploring,
    },
        { 
        title: 'Guest Lecture on "Agile Ways of Working in Software Industry"', 
        date: '03/10/2024',
        time: '12:00 PM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: agile,
    },
    { 
        title: 'Workshop on "Wordpress : A Beginner’s Guide to Website Creation"', 
        date: '25/09/2024',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: wordcamp,
    },
    { 
        title: 'Two Days Workshop on "Fundamentals of PowerBI Hands-on"', 
        date: '19/09/2024',
        time: '11:00 AM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: powerbi,
    },
    { 
        title: 'Idea to Impact – Marathon Series', 
        date: '26/08/2024',
        time: '12:00 PM',
        venue: 'CT Seminar Hall, IT Complex, PCE Nagpur',
        image: idea,
    },
    { 
        title: 'Flutter UI Hackathon', 
        date: '16/08/2024',
        time: '12:00 PM',
        venue: 'IT Complex, PCE Nagpur Campus',
        image: flutter,
    }
];

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.001, duration: 0.5, ease: "easeOut" }
  })
};

const Events = () => {
  return (
    <div className="events-page-container">
      <div className='events-container'>
        <div className="events-header">
          <h1 className="events-title">Our Events</h1>
        </div>
      
        <div className="timeline-container">
          {upcomingEvents.map((event, index) => (
              <motion.div 
                className="timeline-item" 
                key={index}
                custom={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                variants={cardVariants}
              >
                <div className="timeline-dot">
                    {/* The date is now inside the dot */}
                    <div className="timeline-date-dot">{event.date}</div> 
                </div>
                <div className="timeline-content">
                    <div className="event-card-timeline">
                        <img src={event.image} alt={event.title} className="event-image-timeline" />
                        <div className="event-details">
                            <h2 className="event-title-timeline">{event.title}</h2>
                            <p className="event-meta-timeline">
                                <strong>Date:</strong> {event.date}<br/>
                                <strong>Time:</strong> {event.time}<br/>
                                <strong>Venue:</strong> {event.venue}
                            </p>
                        </div>
                    </div>
                </div>
            </motion.div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Events;